/**
 * 应用中心签到模块
 */
export const ApplySignArr = [
  {
    path: "sign/:id(\\d+)",
    name: "sign",
    meta: {
      title: "签到"
    },
    redirect: "/apply/sign/:id(\\d+)/set",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "set",
        name: "set",
        meta: {
          title: "签到规则设置"
        },
        component: () => import("@/views/apply/comModule/sign/set.vue")
      },
      {
        path: "signList",
        name: "signList",
        meta: {
          title: "签到记录"
        },
        component: () => import("@/views/apply/comModule/sign/signgList.vue")
      }
    ]
  }
];
